export enum $userApiKey {
  _id = '_id',
  user = 'user',
  name = 'name',
  hash = 'hash',
  expiry = 'expiry',
  createdAt = 'createdAt',
  type = 'type',
  revoked = 'revoked',
  tenantId = 'tenantId',
  reminderDays = 'reminderDays',
}

export enum $apiTokenGenerationOptions {
  apiTokenName = 'apiTokenName',
  apiTokenExpiryOptions = 'apiTokenExpiryOptions',
  apiTokenCustomExpiry = 'apiTokenCustomExpiry',
  apiTokenAddCustomReminder = 'apiTokenAddCustomReminder',
  apiTokenReminderDays = 'apiTokenReminderDays',
}

export enum generateKeyResult {
  expiry = 'expiry',
}

export enum createApiKeyResult {
  _id = '_id',
  name = 'name',
  key = 'key',
  expiry = 'expiry',
  createdAt = 'createdAt',
}

export enum ApiKeyPrefix {
  browserExtension = 'browserExtension',
  ampTenant = 'AMP_Tenant_API_Key',
  scim = 'scim',
  scanningAgent = 'scanningAgent',
}

export enum ApiKeyType {
  user = 'user',
  browserExtension = 'browserExtension',
  ampTenant = 'ampTenant',
  scim = 'scim',
  scanningAgent = 'scanningAgent',
}

export const API_KEY_EXPIRY_IN_DAYS: Record<ApiKeyType, number> = Object.freeze({
  [ApiKeyType.user]: 6 * 30,
  [ApiKeyType.browserExtension]: 30,
  [ApiKeyType.ampTenant]: 6 * 30,
  [ApiKeyType.scim]: 100 * 365,
  [ApiKeyType.scanningAgent]: 365,
});
